import { axios } from '../axios';
import {baseEnvironment} from '../environment/environment.base';

const v1Version = baseEnvironment.apiVersion1;

const patientLoginRoute = `${v1Version}/${baseEnvironment.apiEndPoints.patientDocumentUpload.loginPatient}`
const getDocumentsRoute = `${v1Version}${baseEnvironment.apiEndPoints.patientDocumentUpload.requiredUploadDocuments}`
const sendOtpRoute = `${v1Version}/${baseEnvironment.apiEndPoints.patientDocumentUpload.sendOtp}`
const uploadDocumentsRoute = `${v1Version}/${baseEnvironment.apiEndPoints.patientDocumentUpload.uploadDocument}`

export const getReferenceId =  async(code:string):Promise<any> =>{
    const response = await axios.get(`${sendOtpRoute}/${code}`)
    return response.data;
}

export const patientLogin = async (otp: number, reference_id: number) : Promise<any> => {
    const response = await axios.post(patientLoginRoute, {otp, reference_id})
    return response.data;
}

export const getDocumentsRequired = async () : Promise<any> => {
    const response = await axios.get(getDocumentsRoute)
    return response.data;
}

export const uploadDocuments = async (documents:any) : Promise<any> => {
    const response = await axios.post(uploadDocumentsRoute, documents, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout:180000
    });
    return response.data;
}